import React from 'react';

const BodyConditionGroupItem = (props) => {
  const {number, content} = props.data;
  const reference = props.reference;
  const {animalType} = props;

  const bodyWeightCondition = (number) => {
    const intNumber = parseInt(number, 10);

    if (intNumber < 4)
      return "underweight";
    else if (intNumber > 5)
      return "overweight";
    else
      return "idealweight";
  }

  let animalContent;
  if (animalType == "dog"){
    animalContent = content.dog;
  } else {
    animalContent = content.cat;
  }

  return (
    <div className={'nppe2-fc-feeding-guidelines-body-condition__group--' + reference + '-txt-wrapper'}>
      <div className={'nppe2-fc-feeding-guidelines-body-condition__group--' + reference + '-txt-number-' + bodyWeightCondition(number)}>
        <div>
          {number}
        </div>
      </div>
      <div className={'nppe2-fc-feeding-guidelines-body-condition__group--' + reference + '-txt-info'}>
        {animalContent}
      </div>
    </div>
  );
}

export default BodyConditionGroupItem;
